export const TOKEN = "AQCHAM_TOKEN";
export const PROFILE = "AQCHAM_PROFILE";
export const POSITION = "AQCHAM_POSITION";

export const token = localStorage.getItem(TOKEN);
export const profile = localStorage.getItem(PROFILE);
export const position = localStorage.getItem(POSITION);
